import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
/* import "firebase/analytics"; */

//datos de la aplicacion dada por firebase
const firebaseConfig = {
  apiKey: "AIzaSyBgVv6FY5OfLLKdYNfLoO9zweHbHuuRyKI",
  authDomain: "iquela-3395e.firebaseapp.com",
  projectId: "iquela-3395e",
  storageBucket: "iquela-3395e.appspot.com",
  messagingSenderId: "1054773738103",
  appId: "1:1054773738103:web:a9f2e407b12c1303f86472",
  measurementId: "G-7QRBNQ714H",
};
//se inicializa firebase
firebase.initializeApp(firebaseConfig);
//se exportan constantes con los servicios que se van a usar, se usa app, que fue
//inicializado y constantes con los servicios de firebase

const firestore = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

export { firestore, auth, storage, firebase };
